var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"nodata"},[_c('div',{staticClass:"iconfont icon-wushuju",staticStyle:{"font-size":"90px","color":"var(--color)","line-height":"100px","padding-top":"25px","text-align":"center"}}),_c('div',[_vm._v(" "+_vm._s(_vm.no_data)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }